import { Link } from 'react-router-dom';
import { ProductBrand } from '@/components/brand/ProductBrand';
import { Card, CardHeader } from '@/components/ui/Card';
import { PrivacyPolicyBody } from '@/content/LegalDocumentBody';
import { LEGAL } from '@/config/legal';

export function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen flex flex-col items-center bg-page px-4 py-12">
      <div className="w-full max-w-3xl">
        <Card>
          <CardHeader className="space-y-6">
            <ProductBrand variant="light" showTagline={false} />
            <div>
              <h1 className="text-headline-md font-semibold text-foreground">Privacy Policy</h1>
              <p className="mt-2 text-body-sm text-foreground-muted">
                Effective Date: {LEGAL.privacyEffectiveDate}
              </p>
              <p className="text-body-sm text-foreground-muted">
                Last updated: {LEGAL.privacyVersion}
              </p>
            </div>
            <PrivacyPolicyBody />
            <p className="text-center text-body-sm">
              <Link to="/signup" className="font-semibold text-brand-deep hover:text-brand hover:underline">
                Back to signup
              </Link>
            </p>
          </CardHeader>
        </Card>
      </div>
    </div>
  );
}
